<template>
  <div class="loginPage">
    <img src="@/assets/images/login/conduct.jpg" class="loginBg" />

    <div class="block">
      <van-button block round color="rgba(255,255,255,.2)" to="/Login?ReturnUrl=/">登 录</van-button>
      <van-button block round color="rgba(255,255,255,.2)" to="/Register">注 册</van-button>
      <van-button block round color="rgba(255,255,255,.2)" to="/Explore">浏 览</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  created() {
    var that = this;
    var _isWeiXin = that.$weixin.IsWeiXin();
    if (_isWeiXin) {
      console.log("微信浏览器进入");
      var openid = sessionStorage.getItem("OpenId");
      if (openid == null) {
        var code = that.$route.query.code;
        that.$weixin.weixinAuthorize(code, that, function() {
          that.$weixin.GetJssdkConfig(that);
        });
      }
    }
  }
};
</script>

<style scoped>
.loginPage .block {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.loginPage .block .van-button {
  margin-bottom: 40px;
  border: 0 none;
  width: 120px;
  height: 50px;
  line-height: 50px;
  font-size: 17px;
}
</style>
